import { render, staticRenderFns } from "./ConfigTabTemplates.vue?vue&type=template&id=3fbb21e6"
import script from "./ConfigTabTemplates.vue?vue&type=script&lang=js"
export * from "./ConfigTabTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports